import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
// import '@carbon/styles/css/styles.css';  // Temporarily disabled - causing conflicts
import './styles/carbon-overrides.css'; // Our custom overrides with Carbon-inspired styling

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
